import type { FooterLink } from './FooterLink';

export function instanceOfFooterLink (object: any): object is FooterLink {

  return (object.name || object.translationKey) && (object.url || object.routeKey);

}
